var map = {
	"./1.png": 8061,
	"./2.png": 4618,
	"./3.png": 4839,
	"./4.png": 9491,
	"./5.png": 1453,
	"./6.png": 5679,
	"./7.png": 7956,
	"./8.png": 3808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5229;